import { gql } from '@apollo/client';
import type { InhubSortingDetailInput } from '../queries/getInhubSortingDetailPage';

export const GENERATE_INHUB_SORTING_DETAIL_EXPORT = gql`
  mutation GenerateInhubSortingDetailExport(
    $filter: InhubSortingDetailInput!
    $timezone: String
  ) {
    generateInhubSortingDetailExport(filter: $filter, timezone: $timezone)
  }
`;

export interface GenerateInhubSortingDetailExportVariables {
    filter: InhubSortingDetailInput;
    timezone?: string;
}

export interface GenerateInhubSortingDetailExportResponse {
    generateInhubSortingDetailExport: string;
}
